import TriggerConfigSerializer from 'eflex/serializers/trigger-config';

export default class LightGuideTriggerConfigSerializer extends TriggerConfigSerializer {}
